module.exports = __webpack_public_path__ + "static/1-35b12a5265717007d0dfaf9f2ab9529e.jpg";